/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowVisualDesignerTokenQueryResponse } from "../../models/GetShowVisualDesignerToken";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowVisualDesignerTokenUrl() {
  const res = { method: 'GET', url: `/api/v1/visual-designer/token` as const }  
  return res
}

/**
 * {@link /api/v1/visual-designer/token}
 */
export async function getShowVisualDesignerToken(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowVisualDesignerTokenQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetShowVisualDesignerTokenUrl().url.toString(), ... requestConfig })  
  return res.data
}